import React, {Component} from 'react';
import './item-with-text.scss';

export default class ItemWithText extends Component {

    render() {
        return <a href={this.props.path} className={"zi-1 ct-item-contact"}>
            <img className={"img-item-text"} src={this.props.imgItem.default} alt=""/>
            <h4>{this.props.title}</h4>
        </a>
    }
}